import { render } from "./addBusiness.vue?vue&type=template&id=60f4d7bf&scoped=true"
import script from "./addBusiness.vue?vue&type=script&lang=js"
export * from "./addBusiness.vue?vue&type=script&lang=js"

import "./addBusiness.vue?vue&type=style&index=0&id=60f4d7bf&lang=less&scoped=true"

import exportComponent from "/root/workspace/service-web_xMds/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f4d7bf"]])

export default __exports__